module.exports = __webpack_public_path__ + "static/img/3.6d5b08a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/5/eng/3.png
// module id = Bt+Z
// module chunks = 0